import clsx from 'clsx';
import React from 'react';
import Collapsible from '../Collapsible';
import ProductTab from '../../Types/ProductTab';
interface ProductPageTabContentProps {
  active: boolean;
  item: ProductTab;
}

const ProductPageTabContent = ({
  item,
  active,
}: ProductPageTabContentProps) => {
  return (
    <>
      <div className={clsx(active && 'lg:block', 'hidden pb-16 pt-8')}>
        {item.content}
      </div>
      <div className="lg:hidden">
        <Collapsible
          className="border-b border-gray-100"
          label={item.title}
          labelClassName="h3 px-4 !text-h3-mobile"
          labelSize="h-4 w-4"
        >
          <div className="border-t border-gray-100 px-4 py-3">
            {item.content}
          </div>
        </Collapsible>
      </div>
    </>
  );
};

export default ProductPageTabContent;
